import { pdfjs } from 'react-pdf';
import createApp from './app';

pdfjs.GlobalWorkerOptions.workerSrc = '//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.1.266/pdf.worker.js';
createApp();
